export const UPDATE_ONBOARDING_TOOLTIP = 'updateOnboardingTooltip';
